// 权限仓库
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("permissionWarehouse") || ""
}

const getters = {
  getPermissionWarehouse:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("permissionWarehouse",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("permissionWarehouse")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}